import React from "react";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
import useProjectFacade from "../../../../facade/project.Facade";
import { useAppSelector } from "../../../../store/hooks/StoreHooks";
import SearchInput from "../../../common/Search";
import { DocumentProjects, DocumentProjectsCustomer, iconDropdownOptions } from "../../../../constants/columns/documents/documents";
import InfiniteScrollComponent from "../../../common/infinite-scroll";

interface IMyProjects {
    setCurrentParams?: any;
    currentParams?: any;
    handleDropdown?: any;
}

const MyAcknowledgeProjects: React.FC<IMyProjects> = ({
    currentParams,
    setCurrentParams,
    handleDropdown,
}) => {
    const { customerEnabled, customerLoading } = useAppSelector((state) => state?.auth);
    const { myAcknowledgeProjects, myAcknowledgeCount, loading } = useAppSelector((state) => state?.documents);
    const navigate = useNavigate();
    const { getUpdatedSelectedProject } = useProjectFacade();

    const handlePageNumberChange = (pageNumber: number): void => {
        setCurrentParams((prev: any) => {
            if (prev.PageNumber !== pageNumber) {
                return {
                    ...prev,
                    PageNumber: pageNumber,
                };
            }
            return prev;
        });
    };

    const handleSortChange = (order: string, field: string): void => {
        if (order === "none") {
            setCurrentParams((prev: any) => ({
                ...prev,
                SortDto: { Field: "", Order: "" },
                PageNumber: 1,
                PageSize: 10,
            }));
        } else {
            setCurrentParams((prev: any) => ({
                ...prev,
                SortDto: { Field: field, Order: order },
                PageNumber: 1,
                PageSize: 10,
            }));
        }
    };

    const handleIncrease = () => {
        const pageSizeOption = [10, 25, 50, 100];
        const findRecord = pageSizeOption.find(
            (item: number) => currentParams.PageSize === item
        );

        if (findRecord) {
            const currentIndex = pageSizeOption.indexOf(findRecord);
            if (currentIndex < pageSizeOption.length - 1) {
                const newPageSize = pageSizeOption[currentIndex + 1];
                setCurrentParams((prevState: any) => ({
                    ...prevState,
                    PageSize: newPageSize,
                    PageNumber: 1,
                }));
            }
        }
    };

    const handleDecrease = () => {
        const pageSizeOption = [10, 25, 50, 100];
        const findRecord = pageSizeOption.find(
            (item: number) => currentParams.PageSize === item
        );
        if (findRecord) {
            const currentIndex = pageSizeOption.indexOf(findRecord);
            if (currentIndex > 0) {
                const newPageSize = pageSizeOption[currentIndex - 1];
                setCurrentParams((prevState: any) => ({
                    ...prevState,
                    PageSize: newPageSize,
                    PageNumber: 1,
                }));
            }
        }
    };

    const handleSearchChange = (
        e: React.ChangeEvent<HTMLInputElement> | string
    ): void => {
        if (typeof e === "string") {
            setCurrentParams((prev: any) => ({
                ...prev,
                GlobalFilter: e,
                PageNumber: 1,
                PageSize: 10,
            }));
        } else {
            setCurrentParams((prev: any) => ({
                ...prev,
                GlobalFilter: e?.target?.value,
                PageNumber: 1,
                PageSize: 10,
            }));
        }
    };

    const handleMainNavigate = (row: any) => {
        (async () => {
            await getUpdatedSelectedProject({
                projectID: row?.projectID,
                projectName: row?.projectName,
                caseID: ""
            });
        })();
        navigate(`/project-details/projectID=${row?.projectID}`);
    };

    const handleNavigate = (row: any, item: any) => {
        (async () => {
            await getUpdatedSelectedProject({
                projectID: row?.projectID,
                projectName: row?.projectName,
                caseID: item?.projectID,
            });
        })();
        navigate(`/project-details/projectID=${row?.projectID}/${row?.projectID !== item?.projectID ? `caseID=${item?.projectID}` : ''}`);
    };

    const loadMore = () => {
        if (currentParams?.PageSize < myAcknowledgeCount) {
            setCurrentParams((prev: any) => {
                return ({
                    ...prev,
                    PageSize: prev?.PageSize + 10,

                })
            });
        }
    };

    return (
        <div className="w-full flex-1">
            <div className="flex flex-col md:flex-row justify-between items-center mb-[20px] space-y-4 md:space-y-0">
                <div className="flex items-center justify-end w-full md:w-auto order-1 md:order-2">
                    <SearchInput
                        searchValue={currentParams?.GlobalFilter}
                        onSearchChange={handleSearchChange}
                        placeholder={"Search"}
                        bgColor="bg-darkcolor-800"
                        width={400}
                    />
                </div>

                <div className="flex items-center justify-start order-2 md:order-1 text-neutral-25">
                    {`Showing ${myAcknowledgeProjects?.length} out of ${myAcknowledgeCount}`}
                </div>
            </div>
            <div>
                <InfiniteScrollComponent
                    data={myAcknowledgeProjects || []}
                    rowsPerPage={1}
                    columns={(!customerLoading && customerEnabled)
                        ? [
                            ...DocumentProjectsCustomer({
                                handleNavigate: handleMainNavigate,
                            })
                        ]
                        : !customerLoading ? [
                            ...DocumentProjects({
                                handleDropdown,
                                iconDropdownOptions,
                                handleNavigate: handleMainNavigate,
                            })
                        ] : []
                    }
                    emptyIcon={true}
                    handleSortChange={handleSortChange}
                    initialSortField={currentParams?.SortDto?.Field}
                    initialSortOrder={currentParams?.SortDto?.Order}
                    minimumHeight={300}
                    totalCount={myAcknowledgeCount}
                    isLoading={loading}
                    overFlowClass="overflow-x-auto"
                    renderExpandedRow={(row) => (
                        <>
                            {row?.caseNameList?.map((item: any, index: number) => (
                                <tr >
                                    <td></td>
                                    <td
                                        className="w-full px-4 py-2 text-neutral-25 text-[14px] font-normal font-Mulish"
                                    >
                                        <Link className="text-[14px] text-primary-400 cursor-pointer truncate w-full hover:underline focus:underline active:underline" to={`/project-details/projectID=${row?.projectID}/${row?.projectID !== item?.projectID ? `caseID=${item?.projectID}` : ''}`} onClick={() => handleNavigate(row, item)}>
                                            <span className="border text-center border-primary-400 rounded px-2 py-1 text-primary-400 mr-1">{item?.liftTypeName}</span>{` ${item.caseName}`} </Link>     {`- created by ${item?.createdBy} and last modified by ${item?.updatedBy} on ${item?.updatedOn && moment(item?.updatedOn).format("DD MMM YYYY")}`}
                                    </td>
                                </tr>
                            ))}
                        </>
                    )}
                    onLoadMore={() => loadMore()}
                />
            </div>
        </div>
    );
};

export default MyAcknowledgeProjects;
